// src/pages/HomePage.jsx
import React, {useState} from "react";
import Hero2 from "../components/Hero2";
import SplashScreen from "../components/SplashScreen";
import { Helmet } from "react-helmet";

export default function HomePage() {
  const [showSplash, setShowSplash] = useState(true);
  return (
    <>
        <Hero2 />
    </>
  );
}